import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import hexOpacity from '@deprecated-ui/utils/hexOpacity';
import Image from 'global/Image';
import { ModalConfirm, PostLimitContainer } from './styled';

interface ModalPostLimitProps {
  readonly onCancel: () => void;
  readonly onSubmit: () => void;
  readonly type: string;
  readonly title: string;
  readonly [key: string]: any;
}

function ModalPostLimit({
  onCancel,
  onSubmit,
  type,
  title,
  ...props
}: Readonly<ModalPostLimitProps>) {
  const getDescription = () => {
    if (type === 'comment') {
      return 'Untuk melindungi komunitas kami, kamu perlu membuka akun Stockbit Sekuritas agar menjadi pengguna terverifikasi sebelum dapat memberikan komentar.';
    }
    return 'Untuk melindungi komunitas kami, kamu perlu membuka akun Stockbit Sekuritas agar menjadi pengguna terverifikasi sebelum dapat membuat postingan.';
  };
  return (
    <ModalConfirm
      onCancel={onCancel}
      centered
      closable
      zIndex={2000}
      width={400}
      footer={
        // @ts-expect-error
        <Flex pb="20px" px="20px" pt="20px" justify="flex-end" align="flex-end">
          <Button
            key="confirm"
            type="primary"
            // @ts-expect-error
            padding="10px 30px"
            width="360px"
            height="40px"
            radius="4px"
            onClick={onSubmit}
          >
            Buka Akun Stockbit Sekuritas
          </Button>
        </Flex>
      }
      maskStyle={{ backgroundColor: `${color.black}${hexOpacity(80)}` }}
      {...props}
    >
      <PostLimitContainer>
        <Image
          src="/illustration/KYC-and-profile.svg"
          alt="Eipo Login Illustration"
          width="160"
          height="120"
        />
        <div className="text-container">
          <Text
            family="bold"
            size="16px"
            weight={700}
            style={{
              marginTop: 16,
              width: title.includes('Post') ? 210 : 220,
              lineHeight: '22px',
            }}
            align="center"
          >
            {title}
          </Text>

          <Text
            align="center"
            size="14px"
            style={{
              marginTop: 16,
              marginBottom: 20,
              lineHeight: '19px',
            }}
            color="#858585"
          >
            {getDescription()}
          </Text>
        </div>
      </PostLimitContainer>
    </ModalConfirm>
  );
}

export default ModalPostLimit;
